import BaseModel from '../core/BaseModel'
export default class SettingUnitModel extends BaseModel {
    constructor() {
        super({ 
                name: "setting_unit",
                tableName: 'core_setting_unit',
                display_key: 'name'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false,
                width: 10
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Loại đơn vị',
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                width: 30
            },
            number_of_subunits: {
                name: 'number_of_subunits', label: 'Số lượng đơn vị cấp con', type: "String", class: 'center',  width: 15
            },
            number_of_accounts: {
                name: 'number_of_accounts', label: 'Số lượng tài khoản', type: "String", class: 'center',  width: 15
            },
            status: {
                name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            }
        },)
    }

}